/** @flow */

import React from "react";
import classNames from "classnames";
import { Icons, TextField, IconButton, Button } from "@components";
import { localize } from "redux-i18n";
import "./style.scss";

type Props = $Exact<{
  ...PropsFromLocalize,
  currentPage: number,
  pagesCount: number,
  showingOption: string,
  className?: string,
  groupedBy: string,
  toggleModalOptions: () => void,
  filterTasks: Function,
  onSearchTasksChange: Function,
  searchValue: string,
  tasksType: string | null,
}>;

export const TasksQueueFilter = (props: Props) => (
  <div className={classNames("w-100 d-flex justify-content-between", props.className)}>
    <div className="d-flex flex-1 justify-content-start">
      <div className="search-tasks-wrap d-flex align-items-center w-100">
        <div className="w-100 ml-2 mr-2">
          <TextField
            onChange={e => props.onSearchTasksChange(e.target.value)}
            value={props.searchValue}
            placeholder={props.t("SEARCH_DOTS")}
            className="search-tasks-wrap__search-input"
            onKeyDown={e => {
              if (e.key === "Enter") {
                props.filterTasks(props.tasksType);
              }
            }}
          />
        </div>
        <IconButton
          icon={<span className="material-icons pointer">search</span>}
          onClick={() => props.filterTasks(props.tasksType)}
        />
      </div>
    </div>
    <div className="d-flex flex-1 justify-content-end">
      <div className="mr-2 d-flex align-items-center">{props.t("FILTER_QUEUE")}:</div>
      <div className="d-flex flex-row">
        <Button
          className={classNames("mr-2", {
            selected: !props.tasksType,
          })}
          materialIcon="select_all"
          onClick={() => props.filterTasks()}
        >
          {props.t("ALL")}
        </Button>
        <Button
          className={classNames("mr-2", {
            selected: props.tasksType === "RTW_INTERVIEW",
          })}
          materialIcon="feed"
          onClick={() => props.filterTasks("RTW_INTERVIEW")}
        >
          {props.t("RTW")}
        </Button>
        <Button
          className={classNames("mr-2", {
            selected: props.tasksType === "ABSENCE_MONITORING_REVIEW",
          })}
          materialIcon="assessment"
          onClick={() => props.filterTasks("ABSENCE_MONITORING_REVIEW")}
        >
          {props.t("MONITORING_TITLE")}
        </Button>
        <Button
          className={classNames("mr-2", {
            selected: props.tasksType === "MANAGER_REFERRAL_DECISION",
          })}
          materialIcon="monitor_heart"
          onClick={() => props.filterTasks("MANAGER_REFERRAL_DECISION")}
        >
          {props.t("REFERRALS")}
        </Button>
      </div>
    </div>
    <div />
  </div>
);

export default localize()(TasksQueueFilter);
